import Month from './Month';

export default Month;
